import React from 'react';
import { useLang } from '../../i18n';
import { STATUS_META } from '../../config/lists';
import { useRowActions } from './rowActions';

/** Touch ⋯ — a bottom action sheet (escapes the row's swipe overflow). */
export function RowSheet({ item, list, actions, moveTargets, onClose, onRename }) {
  const { t, ln } = useLang();
  const a = useRowActions({ item, list, actions, moveTargets });
  const thenRun = run => () => { onClose(); run(); };
  return (
    <div className="do-sheet-back" onClick={onClose}>
      <div className="do-sheet" onClick={e => e.stopPropagation()} role="menu">
        <div className="do-sheet__title">{ln(item.name)}</div>
        {list.sourceable
          ? a.statuses.map(s => (
            <button key={s.key} className={`do-sheet__item${s.on ? ' do-sheet__item--on' : ''}`}
              style={{ '--sc': s.color }} onClick={() => { s.run(); onClose(); }}>
              <span className="do-sheet__ico">{s.icon}</span>{s.label}
            </button>
          ))
          : (
            <button className={`do-sheet__item${a.done.on ? ' do-sheet__item--on' : ''}`}
              style={{ '--sc': STATUS_META.refilled.color }} onClick={() => { a.done.run(); onClose(); }}>
              <span className="do-sheet__ico">✓</span>{a.done.label}
            </button>
          )}
        <div className="do-sheet__sep" />
        <button className="do-sheet__item" style={{ '--sc': 'var(--amber)' }} onClick={thenRun(a.urgent.run)}>
          <span className="do-sheet__ico">{a.urgent.icon}</span>{a.urgent.label}
        </button>
        <div className="do-sheet__sep" />
        <div className="do-sheet__label">{t('menu.moveToList')}</div>
        {a.moves.map(m => (
          <button key={m.id} className="do-sheet__item" style={{ '--sc': m.color }} onClick={thenRun(m.run)}>
            <span className="do-sheet__ico">{m.icon}</span>{m.label}
          </button>
        ))}
        <div className="do-sheet__sep" />
        <button className="do-sheet__item" style={{ '--sc': 'var(--sub)' }} onClick={thenRun(onRename)}>
          <span className="do-sheet__ico">✏️</span>{t('menu.rename')}
        </button>
        {a.fixTelugu && (
          <button className="do-sheet__item" style={{ '--sc': 'var(--sub)' }} onClick={thenRun(a.fixTelugu)}>
            <span className="do-sheet__ico">🌐</span>{t('menu.fixTelugu')}
          </button>
        )}
        <button className="do-sheet__item do-sheet__item--danger" style={{ '--sc': 'var(--red)' }} onClick={thenRun(a.remove)}>
          <span className="do-sheet__ico">🗑</span>{t('menu.delete')}
        </button>
        <button className="do-sheet__cancel" onClick={onClose}>{t('common.cancel')}</button>
      </div>
    </div>
  );
}
